// Minimal sync manager fallback
export const syncManager = {
  createSubscription: () => null,
  removeSubscription: () => {},
  getSyncStatus: () => ({ 
    isOnline: true, 
    queuedOperations: 0, 
    activeSubscriptions: 0, 
    retryingSubscriptions: 0,
    synced: true, 
    lastSync: Date.now() 
  }),
  processSyncQueue: () => {},
  init: () => {},
  start: () => {},
  stop: () => {}
};

export const connectionMonitor = {
  isHealthy: true,
  start: () => {},
  stop: () => {},
  getStatus: () => ({ connected: true, latency: 0 }),
  getHealthStatus: () => ({ 
    isHealthy: true, 
    lastCheck: Date.now(),
    latency: 0,
    connected: true 
  }),
  checkConnection: () => {}
};

export default { syncManager, connectionMonitor };